import isEqual from 'lodash/isEqual';
import { usePreviousRef } from '@direct-frontend/stdlib';

type UsePageWithQueryChangeResetParams<Query> = {
    page: number;
    pageIndependentQuery: Query;
    setPage: (page: number) => void;
    isLocalPagination: boolean;
};

export function usePageWithQueryChangeReset<Query>({
    page,
    pageIndependentQuery,
    setPage,
    isLocalPagination,
}: UsePageWithQueryChangeResetParams<Query>): number {
    const previousQuery = usePreviousRef(pageIndependentQuery).current;
    const shouldResetPage = isLocalPagination && page !== 1 && !isEqual(pageIndependentQuery, previousQuery);

    if (shouldResetPage) {
        // Синхронизируем state до запуска query-hook, чтобы не отправлять новые параметры со старой страницей.
        setPage(1);

        return 1;
    }

    return page;
}
